
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Crown, Lock, Star } from "lucide-react";
import { Link } from "react-router-dom";
import { isAndroidTWA } from "@/utils/runtimeContext";

interface UpgradeBannerProps {
  userPlan: string;
  isFederalLottery: boolean;
}

const UpgradeBanner: React.FC<UpgradeBannerProps> = ({ userPlan, isFederalLottery }) => {
  if (isAndroidTWA()) return null;
  // Só mostra se for usuário free SEM acesso de teste ativo
  if (userPlan !== "free") return null;

  return (
    <Card className="border-amber-300 bg-gradient-to-r from-amber-50 to-yellow-50 shadow-lg mb-6">
      <CardContent className="p-6">
        <div className="flex items-center gap-4">
          <div className="flex items-center justify-center w-12 h-12 bg-amber-100 rounded-full">
            <Crown className="h-6 w-6 text-amber-600" />
          </div>
          <div className="flex-1">
            <h4 className="font-bold text-amber-800 text-lg">
              🎯 Aproveite seu Período de Teste!
            </h4>
            <p className="text-amber-600 text-sm">
              Você tem acesso completo a todas as funcionalidades durante seu teste gratuito de 2 dias.
            </p>
          </div>
          <Link to="/planos">
            <Button className="bg-gradient-to-r from-amber-500 to-yellow-500 hover:from-amber-600 hover:to-yellow-600 text-white font-bold px-6 py-3">
              <Star className="w-4 h-4 mr-2" />
              Ver Planos VIP
            </Button>
          </Link>
        </div>
      </CardContent>
    </Card>
  );
};

export default UpgradeBanner;
